import type { ReactNode } from "react";
import { AlertTriangle } from "lucide-react";
import type { SectionError } from "../api/types.js";

interface PanelProps {
  title: string;
  icon: ReactNode;
  actions?: ReactNode;
  children: ReactNode;
}

export function Panel({ title, icon, actions, children }: PanelProps) {
  return (
    <section className="panel">
      <header className="panel__head">
        <h2 className="panel__title">
          {icon}
          {title}
        </h2>
        <div className="panel__head-spacer" />
        {actions}
      </header>
      {children}
    </section>
  );
}

export function LoadingState({ label = "Loading" }: { label?: string }) {
  return (
    <div className="state" role="status">
      <span className="spinner" aria-hidden="true" /> <span>{label}...</span>
    </div>
  );
}

export function ErrorState({ message }: { message: string }) {
  return (
    <div className="state state--error" role="alert">
      <AlertTriangle size={14} aria-hidden="true" /> {message}
    </div>
  );
}

export function EmptyState({ message }: { message: string }) {
  return <div className="state">{message}</div>;
}

export function SectionErrors({ errors }: { errors: SectionError[] }) {
  if (errors.length === 0) return null;
  return (
    <div className="errors">
      <ul className="list">
        {errors.map((e, i) => (
          <li key={`${e.scope}-${i}`} className="error-note">
            <AlertTriangle size={13} aria-hidden="true" />
            <span>
              <strong>{e.scope}:</strong> {e.message}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
